<script lang="ts">import LlamaIllustration from "../images/llama-illustration.svg";
import TrophyIllustration from "../images/trophy-illustration.svg";
import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isSmallMonitor, isSpecialWidthCase } from "@infinitro/global";
import { Text } from "@infinitro/text";
import "../api/api";
import LeaderboardCard from "./card.svelte";
export let race;
export let raceId = undefined;
</script>

<svelte:head>
	<title>Races</title>
</svelte:head>

<Container width="56.25rem">
	<div class="prize-pool-title">
		<Text
			type="body"
			bodyWeight="bold"
			customStyle="font-size: 2rem !important; line-height: 2.5rem !important;"
			textAlign="center"
		>
			{$t(Verbiage.prize_pool_title_part_1)}
			<span style="color: #FFCE2B;">{$t(Verbiage.prize_pool_title_part_2)}</span>
		</Text>
	</div>

	{#if !$isMobile && !$isSpecialWidthCase && !isSmallMonitor}
		<div class="illustrations">
			<img
				src={LlamaIllustration}
				alt={$t(Verbiage.illustration_alt, 'alts')}
				class="llama-illustration"
			/>
			<img
				src={TrophyIllustration}
				alt={$t(Verbiage.illustration_alt, 'alts')}
				class="trophy-illustration"
			/>
		</div>
	{/if}

	<LeaderboardCard {race} {raceId} inGame={false} />
</Container>

<style>
	.llama-illustration,
	.trophy-illustration {

    position: absolute
}

	.llama-illustration {

    right: -18.75rem;

    top: -5.625rem
}

	.trophy-illustration {

    left: -17.75rem;

    bottom: 4.375rem
}
</style>
